export default __webpack_public_path__ + "static/media/Data-Science-EN.2ff2f54f.jpg";